import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'header']
  static values = {
    opportunityId: String,
    eventDate: String
  }

  connect() {
    // Auto-expand if there are incomplete rooms
    const incompleteRooms = this.element.querySelector('.required-hotel-details')
    if (incompleteRooms) {
      this.open()
    }
  }

  toggle() {
    if (this.contentTarget.classList.contains('closed')) {
      this.open()
    } else {
      this.close()
    }
  }

  open() {
    this.contentTarget.classList.remove('closed')
    this.contentTarget.classList.add('opened')
    this.headerTarget.classList.remove('closed')
    this.headerTarget.classList.add('opened')
  }

  close() {
    this.contentTarget.classList.add('closed')
    this.contentTarget.classList.remove('opened')
    this.headerTarget.classList.add('closed')
    this.headerTarget.classList.remove('opened')
  }
}
